import { ReactNode } from 'react';

import { Lock } from '@zooplus/icons';

import FormControl from '../FormControl/FormControl';
import FormControlWrapper, {
  FormControlWrapperProps,
} from '../FormControlWrapper/FormControlWrapper';

import { useTranslation } from '@hooks/useTranslations';
import { Nullable } from '@types-internal/index';

import styles from './CardNumberFormField.module.scss';

interface CardNumberFormFieldProps extends FormControlWrapperProps {
  /* Id is required for rendering Adyen(data-cse)/Braintree(id) input field*/
  id?: string;
  /* The controller element to add to the end of card number input field, this item controls how the detected
   * brand icon will be displayed, and it controls the behavior of co-branded card (present list of brand, handle
   * the brand selection). */
  detectedBrandsController?: ReactNode;
  /* Indicate that the field is focused. */
  focused?: boolean;
  /* Controls whether the input label should be visible */
  icon?: React.ReactNode;
  dataZta?: Nullable<string>;
}

/**
 * The input field for credit card number to show in the credit card form.
 */
const CardNumberFormField = ({
  id,
  detectedBrandsController,
  errorMessage,
  focused,
  icon,
  labelInline = false,
  hasInfoMessage = true,
  hasLabel = true,
  dataZta,
}: CardNumberFormFieldProps) => {
  const { t } = useTranslation();
  const infoMessage = {
    infoMessage: t('checkout.payment.secure.new'),
    infoMessageIcon: <Lock />,
  };
  return (
    <FormControlWrapper
      labelFor="encryptedCardNumber"
      labelInline={labelInline}
      errorMessage={errorMessage}
      errorZta="errorInputCreditCardNumber"
      {...(hasLabel ? { label: t('checkout.payment.creditcard.card_number') } : {})}
      {...(hasInfoMessage ? infoMessage : {})}>
      <FormControl
        appendixItems={detectedBrandsController}
        innerClassname={styles.noPadding}
        id={id}
        data-cse={id}
        hasError={errorMessage !== null}
        focused={focused}
        data-zta={dataZta ?? 'inputCreditCardNumber'}
        icon={icon}
      />
    </FormControlWrapper>
  );
};

export default CardNumberFormField;
